<template>
  <div class="admin-listados">
    <HeaderGeneral
      vista="Administrar Listados"
      carpeta="Configuración"
      ruta=" - Listados del sistema"
    />

    <b-container fluid class="mt-3">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-row class="mb-3 align-items-center">
              <b-col>
                <h5 class="mb-0">Listados del sistema</h5>
              </b-col>
              <b-col cols="auto">
                <b-button variant="primary" size="sm" @click="abrirModalNuevoListado">
                  <b-icon icon="plus-circle" class="mr-1" />
                  Nuevo listado
                </b-button>
              </b-col>
            </b-row>

            <div v-if="loadingListados" class="text-center py-4">
              <b-spinner variant="primary" label="Cargando..." />
            </div>

            <b-table
              v-else
              :items="listados"
              :fields="camposTablaListados"
              :per-page="perPage"
              :current-page="currentPage"
              striped
              hover
              responsive
              show-empty
              empty-text="No hay listados registrados"
            >
              <template #cell(nombre_lista)="row">
                {{ row.item.data && row.item.data.nombre_lista }}
              </template>
              <template #cell(total_filas)="row">
                <b-badge variant="secondary">
                  {{ row.item.data && row.item.data.rows ? row.item.data.rows.length : 0 }}
                </b-badge>
              </template>
              <template #cell(acciones)="row">
                <b-button
                  variant="outline-info"
                  size="sm"
                  class="mr-1"
                  title="Ver y administrar filas"
                  @click="abrirAdminFilas(row.item)"
                >
                  <b-icon icon="list-ul" />
                </b-button>
                <b-button
                  variant="outline-warning"
                  size="sm"
                  class="mr-1"
                  title="Editar nombre del listado"
                  @click="abrirModalEditarListado(row.item)"
                >
                  <b-icon icon="pencil" />
                </b-button>
                <b-button
                  variant="outline-secondary"
                  size="sm"
                  title="Desactivar listado"
                  @click="confirmarDesactivarListado(row.item)"
                >
                  <b-icon icon="toggle-off" />
                </b-button>
              </template>
            </b-table>

            <b-pagination
              v-if="listados.length > perPage"
              v-model="currentPage"
              :total-rows="listados.length"
              :per-page="perPage"
              align="right"
              size="sm"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <!-- Modal crear/editar listado -->
    <b-modal
      id="modal-listado"
      :title="modoEdicionListado ? 'Editar listado' : 'Nuevo listado'"
      ok-title="Guardar"
      cancel-title="Cancelar"
      @ok="guardarListado"
      @hidden="resetFormListado"
    >
      <b-form>
        <b-form-group label="Nombre del listado" label-for="input-nombre-lista">
          <b-form-input
            id="input-nombre-lista"
            v-model="formListado.nombre_lista"
            placeholder="Ej: tipos_documento"
            trim
          />
        </b-form-group>
      </b-form>
    </b-modal>

    <!-- Modal administrar filas de un listado -->
    <b-modal
      id="modal-filas"
      :title="listadoActivo ? 'Filas: ' + listadoActivo.data.nombre_lista : ''"
      size="xl"
      hide-footer
      @hidden="resetModalFilas"
    >
      <b-row class="mb-2 align-items-center">
        <b-col>
          <b-input-group size="sm">
            <b-input-group-prepend is-text>
              <b-icon icon="search" />
            </b-input-group-prepend>
            <b-form-input
              v-model="busquedaFilas"
              placeholder="Buscar en filas..."
              @input="currentPageFilas = 1"
            />
            <b-input-group-append v-if="busquedaFilas">
              <b-button variant="outline-secondary" size="sm" @click="busquedaFilas = ''; currentPageFilas = 1">
                <b-icon icon="x" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="auto">
          <span class="text-muted small mr-2">{{ filasFiltradas.length }} fila(s)</span>
          <b-button variant="primary" size="sm" @click="abrirModalNuevaFila">
            <b-icon icon="plus-circle" class="mr-1" />
            Nueva fila
          </b-button>
        </b-col>
      </b-row>

      <div v-if="filasListadoActivo.length === 0" class="text-center text-muted py-4">
        Sin filas. Agrega la primera.
      </div>
      <div v-else-if="filasFiltradas.length === 0" class="text-center text-muted py-4">
        No se encontraron filas con "{{ busquedaFilas }}".
      </div>

      <b-table
        v-else
        :items="filasFiltradas"
        :fields="camposDinamicos"
        :per-page="perPageFilas"
        :current-page="currentPageFilas"
        striped
        hover
        responsive
        show-empty
      >
        <template #cell(acciones_fila)="row">
          <b-button
            variant="outline-warning"
            size="sm"
            class="mr-1"
            title="Editar fila"
            @click="abrirModalEditarFila(row.item, row.item.indexOriginal)"
          >
            <b-icon icon="pencil" />
          </b-button>
          <b-button
            variant="outline-danger"
            size="sm"
            title="Eliminar fila"
            @click="confirmarEliminarFila(row.item.indexOriginal)"
          >
            <b-icon icon="trash" />
          </b-button>
        </template>
      </b-table>

      <b-pagination
        v-if="filasFiltradas.length > perPageFilas"
        v-model="currentPageFilas"
        :total-rows="filasFiltradas.length"
        :per-page="perPageFilas"
        align="right"
        size="sm"
      />
    </b-modal>

    <!-- Modal crear/editar fila -->
    <b-modal
      id="modal-fila"
      :title="modoEdicionFila ? 'Editar fila' : 'Nueva fila'"
      ok-title="Guardar"
      cancel-title="Cancelar"
      size="lg"
      @ok="guardarFila"
      @hidden="resetFormFila"
    >
      <b-form>
        <template v-if="camposFormFila.length > 0">
          <b-form-group
            v-for="campo in camposFormFila"
            :key="campo"
            :label="campo"
            :label-for="'input-fila-' + campo"
          >
            <b-form-input
              :id="'input-fila-' + campo"
              v-model="formFila[campo]"
              :placeholder="campo"
              trim
            />
          </b-form-group>
        </template>
        <template v-else>
          <b-alert show variant="info" class="mb-2">
            Define los campos para esta nueva fila.
          </b-alert>
          <div
            v-for="(par, idx) in paresCampos"
            :key="idx"
            class="d-flex align-items-center mb-2"
          >
            <b-form-input v-model="par.key" placeholder="Campo (ej: id)" class="mr-2" size="sm" />
            <b-form-input v-model="par.value" placeholder="Valor" class="mr-2" size="sm" />
            <b-button variant="outline-danger" size="sm" @click="removerPar(idx)">
              <b-icon icon="trash" />
            </b-button>
          </div>
          <b-button variant="outline-secondary" size="sm" @click="agregarPar">
            <b-icon icon="plus" class="mr-1" />
            Agregar campo
          </b-button>
        </template>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Swal from "sweetalert2";

const ConfigRepository = RepositoryFactory.get("config");

export default {
  name: "AdminListados",
  data() {
    return {
      listados: [],
      loadingListados: false,
      currentPage: 1,
      perPage: 15,
      camposTablaListados: [
        { key: "data.id", label: "ID", sortable: true, thStyle: { width: "80px" } },
        { key: "nombre_lista", label: "Nombre del listado", sortable: true },
        { key: "total_filas", label: "Total filas", thStyle: { width: "120px" } },
        { key: "acciones", label: "Acciones", thStyle: { width: "130px" } },
      ],
      modoEdicionListado: false,
      listadoEnEdicion: null,
      formListado: { nombre_lista: "" },
      listadoActivo: null,
      busquedaFilas: "",
      currentPageFilas: 1,
      perPageFilas: 20,
      modoEdicionFila: false,
      filaEnEdicionIdx: null,
      formFila: {},
      camposFormFila: [],
      paresCampos: [{ key: "", value: "" }],
    };
  },
  computed: {
    filasListadoActivo() {
      if (!this.listadoActivo) return [];
      return this.listadoActivo.data.rows || [];
    },
    filasFiltradas() {
      const query = this.busquedaFilas.trim().toLowerCase();
      if (!query) {
        return this.filasListadoActivo.map((fila, idx) => ({ ...fila, indexOriginal: idx }));
      }
      return this.filasListadoActivo
        .map((fila, idx) => ({ ...fila, indexOriginal: idx }))
        .filter((fila) =>
          Object.values(fila).some((v) =>
            String(v).toLowerCase().includes(query)
          )
        );
    },
    camposDinamicos() {
      if (this.filasListadoActivo.length === 0) return [];
      const keys = Object.keys(this.filasListadoActivo[0]);
      const campos = keys.map((k) => ({ key: k, label: k, sortable: true }));
      campos.push({ key: "acciones_fila", label: "Acciones", thStyle: { width: "110px" } });
      return campos;
    },
  },
  mounted() {
    this.cargarListados();
  },
  methods: {
    async cargarListados() {
      this.loadingListados = true;
      try {
        const response = await ConfigRepository.listasDesplegables({ nombre_entidad: "listados" });
        this.listados = Array.isArray(response) ? response : [];
      } catch (e) {
        console.error("Error cargando listados:", e);
        this.$bvToast.toast("Error al cargar los listados.", { title: "Error", variant: "danger", solid: true });
      } finally {
        this.loadingListados = false;
      }
    },

    abrirModalNuevoListado() {
      this.modoEdicionListado = false;
      this.listadoEnEdicion = null;
      this.formListado.nombre_lista = "";
      this.$bvModal.show("modal-listado");
    },
    abrirModalEditarListado(item) {
      this.modoEdicionListado = true;
      this.listadoEnEdicion = item;
      this.formListado.nombre_lista = item.data.nombre_lista || "";
      this.$bvModal.show("modal-listado");
    },
    resetFormListado() {
      this.formListado.nombre_lista = "";
      this.listadoEnEdicion = null;
      this.modoEdicionListado = false;
    },
    async guardarListado(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.formListado.nombre_lista.trim()) {
        this.$bvToast.toast("El nombre del listado es obligatorio.", { title: "Validación", variant: "warning", solid: true });
        return;
      }
      try {
        if (this.modoEdicionListado && this.listadoEnEdicion) {
          const dataActualizada = Object.assign({}, this.listadoEnEdicion.data, {
            nombre_lista: this.formListado.nombre_lista.trim(),
          });
          await ConfigRepository.actualizarEntidad({
            nombre_entidad: "listados",
            id: this.listadoEnEdicion.data.id,
            data: dataActualizada,
          });
          this.$bvToast.toast("Listado actualizado correctamente.", { title: "Éxito", variant: "success", solid: true });
        } else {
          await ConfigRepository.guardarEntidad({
            nombre_entidad: "listados",
            data: { nombre_lista: this.formListado.nombre_lista.trim(), rows: [] },
          });
          this.$bvToast.toast("Listado creado correctamente.", { title: "Éxito", variant: "success", solid: true });
        }
        this.$bvModal.hide("modal-listado");
        await this.cargarListados();
      } catch (e) {
        console.error("Error guardando listado:", e);
        this.$bvToast.toast("Error al guardar el listado.", { title: "Error", variant: "danger", solid: true });
      }
    },

    confirmarDesactivarListado(item) {
      Swal.fire({
        title: "¿Desactivar listado?",
        text: 'Se desactivará "' + item.data.nombre_lista + '". Podrá reactivarlo desde la base de datos.',
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6c757d",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, desactivar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await ConfigRepository.desactivarEntidad({
              nombre_entidad: "listados",
              id_entidad: item.data.id,
            });
            Swal.fire("Desactivado", "El listado ha sido desactivado.", "success");
            await this.cargarListados();
          } catch (e) {
            Swal.fire("Error", "No se pudo desactivar el listado.", "error");
          }
        }
      });
    },

    abrirAdminFilas(item) {
      this.listadoActivo = JSON.parse(JSON.stringify(item));
      this.currentPageFilas = 1;
      this.$bvModal.show("modal-filas");
    },
    resetModalFilas() {
      this.listadoActivo = null;
      this.busquedaFilas = "";
      this.currentPageFilas = 1;
    },

    abrirModalNuevaFila() {
      this.modoEdicionFila = false;
      this.filaEnEdicionIdx = null;
      if (this.filasListadoActivo.length > 0) {
        this.camposFormFila = Object.keys(this.filasListadoActivo[0]);
        const prefilled = {};
        this.camposFormFila.forEach((k) => (prefilled[k] = ""));
        this.formFila = prefilled;
      } else {
        this.camposFormFila = [];
        this.paresCampos = [{ key: "", value: "" }];
        this.formFila = {};
      }
      this.$bvModal.show("modal-fila");
    },
    abrirModalEditarFila(fila, idx) {
      this.modoEdicionFila = true;
      this.filaEnEdicionIdx = idx;
      const filaLimpia = Object.assign({}, fila);
      delete filaLimpia.indexOriginal;
      this.camposFormFila = Object.keys(filaLimpia);
      this.formFila = filaLimpia;
      this.$bvModal.show("modal-fila");
    },
    resetFormFila() {
      this.formFila = {};
      this.camposFormFila = [];
      this.paresCampos = [{ key: "", value: "" }];
      this.filaEnEdicionIdx = null;
      this.modoEdicionFila = false;
    },
    agregarPar() {
      this.paresCampos.push({ key: "", value: "" });
    },
    removerPar(idx) {
      this.paresCampos.splice(idx, 1);
    },
    async guardarFila(bvModalEvt) {
      bvModalEvt.preventDefault();
      let nuevaFila;
      if (this.camposFormFila.length > 0) {
        nuevaFila = Object.assign({}, this.formFila);
        delete nuevaFila.indexOriginal;
      } else {
        const pares = this.paresCampos.filter((p) => p.key.trim() !== "");
        if (pares.length === 0) {
          this.$bvToast.toast("Agrega al menos un campo.", { title: "Validación", variant: "warning", solid: true });
          return;
        }
        nuevaFila = {};
        pares.forEach((p) => { nuevaFila[p.key.trim()] = p.value; });
      }
      const rows = [...this.filasListadoActivo];
      if (this.modoEdicionFila && this.filaEnEdicionIdx !== null) {
        rows[this.filaEnEdicionIdx] = nuevaFila;
      } else {
        rows.push(nuevaFila);
      }
      const dataActualizada = Object.assign({}, this.listadoActivo.data, { rows });
      try {
        await ConfigRepository.actualizarEntidad({
          nombre_entidad: "listados",
          id: this.listadoActivo.data.id,
          data: dataActualizada,
        });
        this.listadoActivo.data = dataActualizada;
        const idx = this.listados.findIndex((l) => l.data.id === this.listadoActivo.data.id);
        if (idx !== -1) {
          this.$set(this.listados, idx, JSON.parse(JSON.stringify(this.listadoActivo)));
        }
        this.$bvToast.toast(
          this.modoEdicionFila ? "Fila actualizada." : "Fila agregada.",
          { title: "Éxito", variant: "success", solid: true }
        );
        this.$bvModal.hide("modal-fila");
      } catch (e) {
        this.$bvToast.toast("Error al guardar la fila.", { title: "Error", variant: "danger", solid: true });
      }
    },

    confirmarEliminarFila(idx) {
      Swal.fire({
        title: "¿Eliminar fila?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const rows = [...this.filasListadoActivo];
          rows.splice(idx, 1);
          const dataActualizada = Object.assign({}, this.listadoActivo.data, { rows });
          try {
            await ConfigRepository.actualizarEntidad({
              nombre_entidad: "listados",
              id: this.listadoActivo.data.id,
              data: dataActualizada,
            });
            this.listadoActivo.data = dataActualizada;
            const idx2 = this.listados.findIndex((l) => l.data.id === this.listadoActivo.data.id);
            if (idx2 !== -1) {
              this.$set(this.listados, idx2, JSON.parse(JSON.stringify(this.listadoActivo)));
            }
            Swal.fire("Eliminado", "La fila ha sido eliminada.", "success");
          } catch (e) {
            Swal.fire("Error", "No se pudo eliminar la fila.", "error");
          }
        }
      });
    },
  },
};
</script>
